<div class="row" [formGroup]="parentForm">
  <ng-container formArrayName="additionalFields">
    @for (group of additionalFields.controls; track group; let i = $index) {
      <ng-container [formGroup] = group>
        @if (this.additionalFieldDefinitions !== undefined) {
          <div class="input-container input-container--lg">
            <label class="input-container__label">
              {{this.additionalFieldDefinitions[i].fieldName}} @if (fieldRequired(this.additionalFieldDefinitions[i])) {
              <span >*</span>
            }
            @if (this.additionalFieldDefinitions[i].fieldType === localTypeEnum.textBox) {
              <input
                id="add-order-msg-field.input-{{this.getFieldNameWithoutWhiteSpace(i)}}"
                type="text"
                class="input-container__field"
                formControlName="fieldValue">
            }
          </label>
          @if (this.additionalFieldDefinitions[i].fieldType === localTypeEnum.dropList) {
            <dx-select-box
              id="add-order-msg-field.select-{{this.getFieldNameWithoutWhiteSpace(i)}}"
              class="input-container__field"
              [dataSource]="this.additionalFieldDefinitions[i].dropListOptions"
              formControlName="fieldValue"
              [showClearButton]="!fieldRequired(this.additionalFieldDefinitions[i])">
            </dx-select-box>
          }
          <app-control-messages class="input-container__error" [control]="group.get('fieldValue')">
          </app-control-messages>
        </div>
      }
    </ng-container>
  }
</ng-container>
</div>

